import { buildQueryHelpers, OperationIds } from '../../util'
import { type AllQueriesForResource } from '../../util/types'
import { moveContent, moveMoment, renameItem } from './cacheTransformFns'
import { type MonthCalendarKey } from './types'
import { useReadMonthCalendar } from './useReadMonthCalendar'

export { monthCalendar } from './requests'
export type { ContentMove, ItemRename, MomentMove } from './cacheTransformFns'
export type {
  MonthCalendarContent,
  MonthCalendarKey,
  MonthCalendarMoment,
  MonthCalendarResponse,
} from './types'

/** Every month window in the workspace. Invalidate this when anything moves. */
export const allMonthCalendarQueries = {
  ...buildQueryHelpers<
    OperationIds.ReadMonthCalendarBFFV1,
    AllQueriesForResource
  >('calendar', null),
}

export const readMonthCalendar = {
  ...buildQueryHelpers<OperationIds.ReadMonthCalendarBFFV1, MonthCalendarKey>(
    'calendar',
    OperationIds.ReadMonthCalendarBFFV1
  ),
  transformCache: {
    moveContent,
    moveMoment,
    renameItem,
  },
  useQuery: useReadMonthCalendar,
}
